import type { MandateStatus } from '@aimmo/contracts';

/** A mandate's state as a badge tone: the list, the detail and a property's mandates agree. */
export const MANDATE_STATUS_TONES = {
  draft: 'neutral',
  active: 'success',
  suspended: 'warning',
  expired: 'warning',
  sold: 'accent',
  rented: 'accent',
  withdrawn: 'danger',
} as const satisfies Record<MandateStatus, string>;
